module.exports = __webpack_public_path__ + "static/screen_meta_tag-0e6f3fd56f1790471715141d55a42a8c.jpg";